import { createAction } from 'redux-actions'
export const HIDE_LOCKOUT_MODAL = 'HIDE_LOCKOUT_MODAL'
export const hideLockoutModal = createAction(HIDE_LOCKOUT_MODAL)
